export const maxKeyTextCount = 10;

export default function isValidKeyText(keyText, keyTextCount) {
  if (keyTextCount >= maxKeyTextCount) {
    return false;
  }

  if (!keyText || typeof keyText !== 'string' || keyText.match(/([^a-zA-Z0-9\s])/) !== null || keyText.split(' ').length > 3) {
    return false;
  }
  
  return true;
}